<form [formGroup]="formData" novalidate (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Company</label>
          <input
            class="form-control"
            type="text"
            placeholder="Company"
            formControlName="companyName"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.companyName"
          >
          </control-messages>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'CLIENTS.SHIPPING_ADDRESS' | translate }}</label>
          <input
            class="form-control"
            type="text"
            placeholder="{{ 'CLIENTS.SHIPPING_ADDRESS' | translate }}"
            formControlName="address"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls?.address"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'CLIENTS.SHIPPING_ADDRESS_LINE_2' | translate }}</label>
          <input
            class="form-control"
            type="text"
            placeholder="{{ 'CLIENTS.SHIPPING_ADDRESS_LINE_2' | translate }}"
            formControlName="addressLine2"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls?.addressLine2"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'CLIENTS.SHIPPING_CITY' | translate }}</label>
          <input
            class="form-control"
            type="text"
            placeholder="{{ 'CLIENTS.SHIPPING_CITY' | translate }}"
            formControlName="city"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls?.city"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'CLIENTS.SHIPPING_STATE' | translate }}</label>
          <input
            class="form-control"
            type="text"
            placeholder="{{ 'CLIENTS.SHIPPING_STATE' | translate }}"
            formControlName="state"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls?.state"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Country</label>
          <cnc-ui-countries
            [initialValue]="formData?.value?.country"
            [required]="true"
            (changeCountry)="onCountryChange($event)"
          ></cnc-ui-countries>
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls?.country"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'CLIENTS.SHIPPING_ZIP' | translate }}</label>
          <input
            class="form-control"
            type="text"
            placeholder="{{ 'CLIENTS.SHIPPING_ZIP' | translate }}"
            formControlName="postalCode"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls?.postalCode"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'CLIENTS.ACCOUNT_NUMBER' | translate }}</label>
          <input
            class="form-control"
            type="text"
            placeholder="{{ 'CLIENTS.ACCOUNT_NUMBER' | translate }}"
            formControlName="accountNumber"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls?.accountNumber"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'CLIENTS.SHIPPING_TYPE' | translate }}</label>
          <input
            class="form-control"
            type="text"
            placeholder="{{ 'CLIENTS.SHIPPING_TYPE' | translate }}"
            formControlName="shippingType"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls?.shippingType"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'CLIENTS.COMPANY_CONTACT_FIRSTNAME' | translate }}</label>
          <input
            class="form-control"
            type="text"
            placeholder="{{ 'CLIENTS.COMPANY_CONTACT_FIRSTNAME' | translate }}"
            formControlName="firstName"
            lumTextOnly
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls?.firstName"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'CLIENTS.COMPANY_CONTACT_LASTNAME' | translate }}</label>
          <input
            class="form-control"
            type="text"
            placeholder="{{ 'CLIENTS.COMPANY_CONTACT_LASTNAME' | translate }}"
            formControlName="lastName"
            lumTextOnly
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls?.lastName"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'CLIENTS.COMPANY_CONTACT_PHONE' | translate }}</label>
          <input
            class="form-control"
            type="text"
            placeholder="{{ 'CLIENTS.COMPANY_CONTACT_PHONE' | translate }}"
            formControlName="phoneNumber"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls?.phoneNumber"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'CLIENTS.COMPANY_CONTACT_EMAIL' | translate }}</label>
          <input
            class="form-control"
            type="text"
            placeholder="{{ 'CLIENTS.COMPANY_CONTACT_EMAIL' | translate }}"
            formControlName="email"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls?.email"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{ 'CLIENTS.NOTES' | translate }}</label>
          <textarea
            class="form-control"
            type="text"
            placeholder="{{ 'CLIENTS.NOTES' | translate }}"
            formControlName="notes"
            rows="3"
          ></textarea>
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls?.notes"
          >
          </control-messages>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <mat-checkbox color="primary" (change)="showOptions($event)">
            Same as business address
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-danger"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>
    <button
      type="submit"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="formData.invalid || loading"
      id="kt_submit"
      class="btn btn-primary btn-elevate kt-btn-primary"
      [translate]="'BUTTONS.SAVE'"
    >
      <i class="fas fa-save"></i> Save
    </button>
  </div>
</form>
